/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfAccountEntrySummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type PaginatedListOfAccountEntrySummary, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { CancelPendingRequestBuilderRequestsMetadata, type CancelPendingRequestBuilder } from './cancelPending/index.js';
// @ts-ignore
import { CommitPendingRequestBuilderRequestsMetadata, type CommitPendingRequestBuilder } from './commitPending/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/{id}/entries
 */
export interface EntriesRequestBuilder extends BaseRequestBuilder<EntriesRequestBuilder> {
    /**
     * The cancelPending property
     */
    get cancelPending(): CancelPendingRequestBuilder;
    /**
     * The commitPending property
     */
    get commitPending(): CommitPendingRequestBuilder;
    /**
     * GetAccountEntries
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfAccountEntrySummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<EntriesRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfAccountEntrySummary | undefined>;
    /**
     * GetAccountEntries
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<EntriesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetAccountEntries
 */
export interface EntriesRequestBuilderGetQueryParameters {
    criteria?: string;
    pageNumber?: number;
    pageSize?: number;
    sortExpression?: string;
}
/**
 * Uri template for the request builder.
 */
export const EntriesRequestBuilderUriTemplate = "{+baseurl}/accounts/{id}/entries{?Criteria*,PageNumber*,PageSize*,SortExpression*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const EntriesRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "criteria": "Criteria",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
    "sortExpression": "SortExpression",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const EntriesRequestBuilderNavigationMetadata: Record<Exclude<keyof EntriesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    cancelPending: {
        requestsMetadata: CancelPendingRequestBuilderRequestsMetadata,
    },
    commitPending: {
        requestsMetadata: CommitPendingRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const EntriesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: EntriesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfAccountEntrySummaryFromDiscriminatorValue,
        queryParametersMapper: EntriesRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
